import { Award, Users, Calendar } from "lucide-react";
import { useLocale } from "@/i18n/LocaleContext";

const TrustBar = () => {
  const { t } = useLocale();

  const trustItems = [
    { icon: Calendar, title: t("trust.years.title"), subtitle: t("trust.years.subtitle") },
    { icon: Users, title: t("trust.cases.title"), subtitle: t("trust.cases.subtitle") },
    { icon: Award, title: t("trust.reference.title"), subtitle: t("trust.reference.subtitle") },
  ];

  return (
    <section className="bg-primary py-6 md:py-8">
      <div className="container mx-auto px-4">
        {/* Mobile: single horizontal row, compact */}
        <div className="flex md:hidden items-start justify-around gap-2">
          {trustItems.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center gap-1 flex-1">
              <div className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center">
                <item.icon className="h-4 w-4 text-primary-foreground" />
              </div>
              <p className="text-sm font-bold text-primary-foreground leading-tight">{item.title}</p>
              <p className="text-[11px] text-primary-foreground/80 leading-tight">{item.subtitle}</p>
            </div>
          ))}
        </div>
        {/* Desktop: original 3-col grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-6">
          {trustItems.map((item, index) => (
            <div key={index} className="flex items-center justify-center gap-4 text-left">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary-foreground/10 flex items-center justify-center">
                <item.icon className="h-6 w-6 text-primary-foreground" />
              </div>
              <div>
                <p className="text-xl font-bold text-primary-foreground">{item.title}</p>
                <p className="text-sm text-primary-foreground/80">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
